import React from "react";
import InquiryDetailContainer from "../containers/InquiryDetailContainer";

export default function InquiryDetail() {
  return <InquiryDetailContainer />;
}
